import { emit } from "../../core/state.js";
import { getTheme } from "../../core/configAccessors.js";

export default class PromoPoster {
  render() {
    // Accept both nested `theme.promo_poster` object (offline stub) and flat
    // `theme.promo_poster_*` keys (admin-driven, since BE only stores strings).
    const nested = getTheme("promo_poster", null) || {};
    const imageUrl = nested.image_url || getTheme("promo_poster_image_url", null);
    if (!imageUrl) return null;

    const alt        = nested.alt        || getTheme("promo_poster_alt", "") || "";
    // Prefer promo_poster_link_url; fall back to banner_link_url (Halleck admin
    // only configures the latter for the clickable hero).
    const linkUrl    = nested.link_url
      || getTheme("promo_poster_link_url", null)
      || getTheme("banner_link_url", null);
    const clickRaw   = nested.clickable !== undefined ? nested.clickable : getTheme("promo_poster_clickable", null);
    const clickable  = !!linkUrl || clickRaw === true || clickRaw === "true";

    const poster = { image_url: imageUrl, alt, link_url: linkUrl, clickable };

    const wrap = document.createElement("div");
    wrap.className = "ws-promo-poster";

    const img = document.createElement("img");
    img.className = "ws-promo-poster-img";
    img.alt = alt;
    // Collapse the slot until the image loads, so no blank strip is reserved on
    // initial load. Reveal on load; drop the whole poster if it can't load
    // (e.g. an unreplaced CDN_BASE token) — never a broken icon or blank space.
    img.style.height = "0";
    img.onload = () => { img.style.height = ""; };
    img.onerror = () => wrap.remove();
    img.src = imageUrl;
    if (img.complete && img.naturalHeight) img.style.height = "";
    wrap.appendChild(img);

    if (clickable) {
      wrap.classList.add("ws-clickable");
      wrap.addEventListener("click", () => {
        emit("ws-promo-click", { poster });
        if (linkUrl) {
          window.open(linkUrl, "_blank", "noopener,noreferrer");
        }
      });
    }

    return wrap;
  }
}
